import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Button,
  ButtonGroup,
  LinearProgress,
  Tooltip,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Radio,
  TableCell
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getArbitrator } from "../../adapter/arbitratorAdapter";
import { SearchOutlined } from "@mui/icons-material";
import Loader from "../../components/Loader";
import ArbitratorEdit from "./ArbitratorEdit";

export default function ArbitratorList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [EditId,setEditId]= useState()
  const [isUpdated,setIsupdated] = useState(false)
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const navigate = useNavigate();
 console.log(EditId)
 const handleEdit = (id) => {
  console.log(id)
 setEditId(data.filter(function (hero) {
   return hero.id === id;
 }))
};
  useEffect(() => {
    setLoading(true);
    getArbitrator()
      .then((result) => {
        setLoading(false);
        setIsupdated(false)
        setEditId()
        if (result && result.data) {
          setData(result.data);
          setEditId(data[0].id)
          handleEdit(data[0].id)
        }
      })
      .catch((error) => {
        setLoading(false);
        setIsupdated(false)
        setEditId()
        console.error("Error fetching arbitrator data:", error);
      });
  }, [isUpdated]);

   useEffect(()=>{
    
   },[EditId])
   

   const handleUpdate = (value) =>{
     setIsupdated(value)
   }



  const handleView = (id) => {
    const selectedArbitrator = data.find((item) => item.id === id);

    if (selectedArbitrator) {
      navigate("/app/arbitrators/arbitrator", {
        state: { navigationData: selectedArbitrator },
      });
    }
  };

  const availabilityDescriptions = [
    "0. No availability",
    "1. Restricted availability",
    "2. Limited availability",
    "3. Moderate availability",
    "4. Sufficient availability",
    "5. Total availability",
  ];

  const columns = [
    {
      name: "",
      label: "   ",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Radio
              checked={tableMeta.rowIndex === selectedRowIndex}
              
              onChange={() => {setSelectedRowIndex(tableMeta.rowIndex)
                console.log(tableMeta.rowIndex)
                handleEdit(data[tableMeta.rowIndex].id)
              }
              }
            />
          );
        },
      },
    },
    {
      name: "pseudonym",
      label: "Pseudonym",
      width: 100,
      options: {
        customHeadRender: (columnMeta) => {
          return (
            <th
              key={columnMeta.index}
              style={{
                padding: "16px",
                textAlign: "left",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              {columnMeta.label}
            </th>
          );
        },
      },
    },
    {
      name: "availabilityClass",
      label: "Availability class",
      width: 100,
      options: {
        customHeadRender: (columnMeta) => {
          return (
            <th
              key={columnMeta.index}
              style={{
                padding: "16px",
                textAlign: "left",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              {columnMeta.label}
            </th>
          );
        },
        customBodyRenderLite: (
          dataIndex,
          rowIndex,
          columnIndex,
          columnIndexCopy,
          rowIndexCopy
        ) => {
          const stateAvailability = data[dataIndex].availabilityClass;
          const mappedAvailability =
            availabilityDescriptions[stateAvailability] || stateAvailability;
          return (
            <span
              style={{
                display: "block",
                textAlign: "left",
              }}
            >
              {mappedAvailability}
            </span>
          );
        },
      },
    },
    {
      name: "category",
      label: "Category",
      width: 100,
      options: {
        customHeadRender: (columnMeta) => {
          return (
            <th
              key={columnMeta.index}
              style={{
                padding: "16px",
                textAlign: "left",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              {columnMeta.label}
            </th>
          );
        },
      },
    },
    // {
    //   name: "id",
    //   label: "Action",
    //   width: 150,
    //   options: {
    //     filter: true,
    //     customHeadRender: (columnMeta) => {
    //       return (
    //         <th key={columnMeta.index} style={{ color: "rgba(0, 0, 0, 0.6)" }}>
    //           {columnMeta.label}
    //         </th>
    //       );
    //     },
    //     customBodyRender: (value) => {
    //       return (
    //         <div style={{ textAlign: "center" }}>
    //           <ButtonGroup style={{ alignContent: "center" }}>
    //             <Tooltip title="Edit">
    //               <Button
    //                 style={{
    //                   color: "rgb(0, 81, 134)",
    //                   border: "none",
    //                   cursor: "pointer",
    //                 }}
    //               >
    //                 <EditIcon
    //                   onClick={() => handleEdit(value)}
    //                   sx={{ width: "20px" }}
    //                 />
    //               </Button>{" "}
    //             </Tooltip>
    //           </ButtonGroup>
    //         </div>
    //       );
    //     },
    //   },
    // },
  ];

  const options = {
    onRowClick: (rowData, rowMeta) => {
      setSelectedRowIndex(rowMeta.dataIndex);
      handleEdit(data[rowMeta.dataIndex].id)
    },
    pagination: true,
    selectableRows: "none",
    rowHover: true,
    customBodyRender: (value, tableMeta, updateValue) => {
      return (
        <span
          style={{
            display: "block",
            textAlign: tableMeta.columnData[tableMeta.colIndex].align || "left",
          }}
        >
          {value}
        </span>
      );
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        style: {
          background: rowIndex === selectedRowIndex ? 'linear-gradient(118deg, rgb(143, 208, 251), rgba(42, 154, 227, 0.81))' : 'inherit',
           color: rowIndex === selectedRowIndex ? '#ffff' : 'inherit'
        },
      }
    }
  };

  return (
    <>
      <div className="navView">
        <Loader loading={loading} />
        <ToastContainer />
        <div
          className="component-titleContainer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="component-title">Arbitrators</h2>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {/* <FormControl style={{ width: "600px" }}>
          
          </FormControl> */}
          <Link style={{ textDecoration: "none" }} to="/app/arbitrator/create">
            <Button
              color="secondary"
              fullWidth
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Create +
            </Button>
          </Link>
        </div>
        {loading ? (
          <LinearProgress />
        ) : (
          <div style={{display:'grid',gridTemplateColumns:`${EditId ?'70% 30%' : '100%' }`,transition:'1s all ease-in'   }}>
          <MUIDataTable data={data} columns={columns} options={options}  components={{
        TableBodyCell: ({ children, ...props }) => (
          <TableCell
            {...props}
            style={{
              backgroundColor: props.rowIndex === selectedRowIndex ? '#00000' : 'inherit',
            }}
          >
            {children}
          </TableCell>
        ),
      }} />
          {
            EditId  &&   <ArbitratorEdit EditData={EditId} updated={handleUpdate}/>
          }
        
          </div>
        
          
        )}
        
      </div>
    </>
  );
}
